import { render, staticRenderFns } from "./Add copy.vue?vue&type=template&id=36695f16&scoped=true"
import script from "./Add copy.vue?vue&type=script&lang=js"
export * from "./Add copy.vue?vue&type=script&lang=js"
import style0 from "./Add copy.vue?vue&type=style&index=0&id=36695f16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36695f16",
  null
  
)

export default component.exports